import React, { FC } from 'react';
import { WithStyle } from '../../utils/with-style';
import { ModalDialogStyled } from './modal.styled';
import { ModalDialogProps } from './types';

const ModalDialog: FC<ModalDialogProps> & WithStyle = props => {
  const stopPropagation = (e: React.MouseEvent) => e.stopPropagation();
  return <ModalDialogStyled onClick={stopPropagation} {...props} />;
};

export default ModalDialog;
